<template>
<fragment :class="[Object.entries(itemsCart.list).length <= 0 ? 'col-md-12' : null]">
    <LoadingApp
        :isLoading.sync="isLoading" 
        :is_full_page="true"
    /> 
    <template v-if="Object.entries(itemsCart.list).length > 0">
        <div  class="col-lg-8">
            <cart-table-container class="cart-table-container">
                <table  class="table table-cart">
                    <thead>
                        <tr>
                            <th class="product-col">Produto</th>
                            <th class="price-col"></th>
                            <th class="qty-col">Quantidade</th>
                            <th>Remover</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, key) in itemsCart.list">
                            <tr :key="key" class="product-row">
                                <td class="product-col">
                                    <figure class="product-image-container">
                                        <a 
                                            :href="item.url_pro" 
                                            class="product-image"
                                        >   
                                            <vue-load-image>
                                                <img slot="image" :src="item.image_main" :title="item.pro_name_site">
                                                <img slot="preloader" :src="$baseUrl+'assets/images/loading-image.gif'"/>
                                                <div slot="error">Erro ao carregar a imagem</div>
                                            </vue-load-image>
                                        </a>
                                    </figure>
                                    <span>
                                        <h1>
                                            <a :href="item.url_pro">
                                                <template v-if="products_settings.show_code_original_beside_description == true && item.api_cod_original">{{ item.api_cod_original }} - </template>
                                                {{ item.pro_name_site }}
                                            </a>
                                        </h1>
                                        <h5 v-if="item.size_name_cart"><br>
                                            <br v-if="!item.color_name_cart">
                                            Tamanho: {{item.size_name_cart}} 
                                        </h5>
                                        <h5 v-if="item.color_name_cart"><br>
                                            <template v-if="item.type == 'COLOR'">Cor:</template>
                                            <template v-if="item.type == 'ESTAMPA'">Estampa:</template>
                                            {{item.color_name_cart}} 
                                        </h5>
                                    </span>
                                </td>
                                <td></td>
                                <td>
                                    <c-input-qtd class="input-quantity-cart">
                                        <input
                                            type="text"
                                            v-model="item.qtd_cart"
                                            @blur="onBlurMinimumQuantity(item, item.qtd_cart)"
                                        >
                                        <div class="buttons-quantity-cart">
                                            <button
                                                class="btn-quantity-plus"
                                                @click="setQuantityPlus(item)"
                                            >
                                                <i class="fas fa-caret-up"></i>
                                            </button>
                                            <button
                                                class="btn-quantity-minus"
                                                @click="setQuantityMinus(item)"
                                            >
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                        </div>
                                    </c-input-qtd>
                                </td>
                                <td>
                                    <a 
                                        href="#" 
                                        @click.prevent.stop="removeItem(item.id, item.key_cart)"
                                        title="Remover produto" 
                                        class="btn-remove"
                                    >
                                        <span class="sr-only">Remover</span>
                                    </a>
                                </td>
                            </tr>
                        </template>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td colspan="4" class="clearfix">
                                <div class="float-left">
                                    <c-ancora
                                        :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                        padding=".85rem 2rem"
                                        fontFamily="Open Sans, sans-serif"
                                        textTransform="initial"
                                        :color="btn_limpar_carrinho.color"
                                        :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                                        :colorHover="$root.$children[0].theme.products.button.color_hover"
                                        :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                                        backgroundColor="transparent"
                                        :borderColor="btn_limpar_carrinho.border_color"
                                        fontSize="1.4rem"
                                        height="unset"
                                        href="#" 
                                        @click.prevent.stop="destroyCart()" 
                                    >
                                        <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">Limpar carrinho</span>
                                    </c-ancora>
                                </div>

                                <div class="float-right">
                                        <c-ancora
                                            padding=".85rem 2rem"
                                            fontFamily="Open Sans, sans-serif"
                                            textTransform="initial"
                                            :backgroundColor="$root.$children[0].theme.products.button.background_color"
                                            :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                                            :color="$root.$children[0].theme.products.button.color"
                                            :colorHover="$root.$children[0].theme.products.button.color_hover"
                                            :borderColor="$root.$children[0].theme.products.button.border_color"
                                            :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                                            :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                            fontSize="1.4rem"
                                            height="unset"
                                            :href="itemsCart.last_url_category || $baseUrl"
                                        >
                                            <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                                                Pesquisar mais
                                            </span>
                                        </c-ancora>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </cart-table-container>
        </div>
        <div class="col-lg-4">
            <FormularioPedido />
            <aside class="sidebar-product padding-left-lg mobile-sidebar">
            </aside>
        </div>
    </template>
    <div 
        v-if="Object.entries(itemsCart.list).length <= 0" 
        class="col-md-12" 
        style="height:calc(50vh);display:flex; align-items:center;justify-content:center"
    >
        <span>
            <h2 style="color:#DB1;">Seu carrinho de compras esta vazio :(</h2>
        </span>
    </div>
</fragment>
</template>

<script>
import LoadingApp from '../../components/LoadingApp'
import VueLoadImage from 'vue-load-image'
import { Fragment } from 'vue-fragment'
import Currency from '../../helpers/parseCurrency'
import {mapState, mapActions} from 'vuex'
import {CAncora} from '../../components/Styles/Button/styled'
import FormularioPedido from './FormularioPedido'
import { CCartTableContainer, CInputQtd } from '../../components/Styles/Template/styled'

export default {
    name: 'CartOrcamento',
    props: {
        items_cart:{default:[]},
        cepdestination:{default:null},
        products_settings:{required:true}
    },
    components: {
        LoadingApp,
        Fragment,
        'vue-load-image': VueLoadImage,
        'c-ancora': CAncora,
        FormularioPedido,
        'c-input-qtd': CInputQtd,
        'cart-table-container': CCartTableContainer
    },
    data() {
        return {
            isLoading: false,
            currency: Currency,
            data: null,
            textTransform: this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? '',
            btn_limpar_carrinho: {
                border_color: this.$root.$children[0].theme?.products?.button?.btn_limpar_carrinho?.border_color ?? '#ccc',
                color: this.$root.$children[0].theme?.products?.button?.btn_limpar_carrinho?.color ?? '#777'
            }
        }
    },
    created() {
        this.ActionSetItemsCart(this.items_cart)
    },
    mounted() {
        var self = this
        $(function () {
            jQuery('.qtd_product').TouchSpin({
                verticalbuttons: true,
                verticalup: '',
                verticaldown: '',
                verticalupclass: 'icon-up-dir',
                verticaldownclass: 'icon-down-dir',
                buttondown_class: 'btn btn-outline',
                buttonup_class: 'btn btn-outline',
                initval: 1,
                min: 1
            })
            jQuery('.qtd_product').on('touchspin.on.startdownspin', function (e) {
                let { value, dataset } = e.target
                self.data = {
                    pro_id: dataset.proid,
                    key: dataset.key,
                    qtd: value,
                    action: 'decrement'
                }
                self.updateCart()
            })
            jQuery('.qtd_product').on('touchspin.on.startupspin', function (e) {
                let { value, dataset } = e.target
                self.data = {
                    pro_id: dataset.proid,
                    key: dataset.key,
                    qtd: value,
                    action: 'increment'
                }
                self.updateCart()
            })
        })
    },
    methods: {
        ...mapActions("cart", [
            "ActionRemoveItemCart",
            "ActionUpdateItemCart",
            "ActionSetItemsCart",
            "ActionDestroyCart"
        ]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        setQuantityMinus(item) {
            let qtd = Number(item.qtd_cart)
            let min = Number(item?.quantity_conversion_factor > item.minimum_sale_quantity ? item.quantity_conversion_factor : item.minimum_sale_quantity)
            if(qtd < 2 || qtd <= min) {
                this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
                qtd = min
                return
            }
            let resto = Number(qtd) % Number(item.quantity_conversion_factor)
            let qtdSobra = resto == 0 ? Number(item.quantity_conversion_factor) - resto : resto
            let qtdAdd = Number(qtd) - qtdSobra
            qtd = qtdAdd < Number(min) ? Number(min) : qtdAdd

            this.data = {
                pro_id: item.id,
                key: item.key_cart,
                qtd: qtd,
                action: 'decrement'
            }
            this.updateCart()
        },
        setQuantityPlus(item) {
            let qtd = Number(item.qtd_cart)
            let max = item?.maximum_sale_quantity
            if(max && qtd >= max) {
                this.alertToast(`Quantidade máxima atingida para este produto.`)
                return
            }
            let resto = Number(qtd) % Number(item.quantity_conversion_factor)
            let qtdFalta = Number(item.quantity_conversion_factor) - resto
            if(max && (qtdFalta + Number(qtd)) > Number(max)) {
                this.alertToast(`Quantidade máxima atingida para este produto.`)
                qtd = Number(max)
                return
            }
            qtd = qtdFalta + Number(qtd)

            this.data = {
                pro_id: item.id,
                key: item.key_cart,
                qtd: qtd,
                action: 'increment'
            }
            this.updateCart()
        },
        onBlurMinimumQuantity(item, qtd) {
            let quantity = qtd
            let min = Number(item?.quantity_conversion_factor > item.minimum_sale_quantity ? item.quantity_conversion_factor : item.minimum_sale_quantity)
            let max = item?.maximum_sale_quantity

            if(Number(quantity) < Number(min)) {
                this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
                item.qtd_cart = Number(min)
                quantity = Number(min)
                this.data = {
                    pro_id: item.id,
                    key: item.key_cart,
                    qtd: quantity,
                    action: 'setQtd'
                }
                this.updateCart()
                return
            }
            let resto = Number(quantity) % Number(item.quantity_conversion_factor)
            let qtdFalta = Number(item.quantity_conversion_factor) - resto
            let qtdSobra = resto == 0 ? Number(item.quantity_conversion_factor) - resto : resto

            if(max && Number(quantity) >= Number(max)) {
                // this.alertToast(`Este produto possui quantidade máxima de ${max}.`)
                if(Number(quantity) > max) {
                    this.alertToast(`Este produto possui quantidade máxima de ${max} ${item.pro_sigla_medida}`)
                    item.qtd_cart -= Number(qtdSobra)
                    quantity -= Number(qtdSobra)
                    return
                }
                if(qtdSobra != Number(item.quantity_conversion_factor)) {
                    this.alertToast(`Quantidade máxima atingida.`)
                    item.qtd_cart -= Number(qtdSobra)
                    quantity -= Number(qtdSobra)
                    return
                }
                // item.qtd_cart = Number(max)
                // quantity = Number(max)
                this.data = {
                    pro_id: item.id,
                    key: item.key_cart,
                    qtd: quantity,
                    action: 'setQtd'
                }
                this.updateCart()
                return
            }
            
            if(resto != 0) {
                if(qtdFalta <= qtdSobra) {
                    quantity = qtdFalta + Number(quantity)
                } else {
                    quantity = Number(quantity) - qtdSobra
                }
            }

            // if(Number(quantity) < Number(min)) {
            //     this.alertToast(`Este produto possui quantidade mínima de ${min}.`)
            //     quantity = Number(min)
            //     return
            // }

            // console.log(quantity)
            // console.log(item)

            // let info = event.target
            // if(isNaN(parseInt(info.value))) {
            //     info.value = qtd_atual
            // }
            // if(!info.value || info.value == '') {
            //     info.value = 1
            // }
            // if(info.value < 1) {
            //     info.value = 1
            // }
            this.data = {
                pro_id: item.id,
                key: item.key_cart,
                qtd: quantity,
                action: 'setQtd'
            }
            this.updateCart()
        },
        alertToast(msg = null, icon = "exclamation", theme = 'warning', timer = 7) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            this.setShowToast(true)
            setTimeout(() => {
                this.setShowToast(false)
            }, (timer * 1000));
        },
        async updateCart() {   
            this.isLoading = true
            await this.ActionUpdateItemCart(this.data)
            .then((response) => {
                this.isLoading = false
                let { data } = response
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                this.isLoading = false
                this.alertToast(error?.msg ?? error)
                // this.$swal({
                //     title: `<span style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 600;">
                //             ${error?.msg ?? error}
                //         </span>`,
                //     icon: 'warning',
                //     confirmButtonColor: '#3085d6',
                //     confirmButtonText: `<span style="font-size: 1.6rem; font-weight: 500">OK</span>`,
                //     background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                // })
            })
        },
        async removeItem(pro_id, index) {   
            this.isLoading = true
            let data = {
                pro_id: pro_id,
                key: index
            }
            await this.ActionRemoveItemCart(data)
            .then((resp) => {
                this.isLoading = false
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                this.isLoading = false
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },  
        async destroyCart() {   
            this.isLoading = true
            await this.ActionDestroyCart()
            .then((resp) => {
                this.isLoading = false
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                this.isLoading = false
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        getQtdVModel(event, qtd_atual) {
            let info = event.target
            if(isNaN(parseInt(info.value))) {
                info.value = qtd_atual
            }
            if(!info.value || info.value == '') {
                info.value = 1
            }
            if(info.value < 1) {
                info.value = 1
            }
            this.data = {
                pro_id: info.dataset.proid,
                key: info.dataset.key,
                qtd: info.value,
                action: 'setQtd'
            }
            this.updateCart()
        }
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ])
    },
    watch: {
        itemsCart(cart) {
            if(!cart) return
            cart.list.forEach(element => {
                element.pro_name_site = this.textTransform == 'uppercase' ? element.pro_name_site.toUpperCase() :
                    this.textTransform == 'lowercase' ? element.pro_name_site.toLowerCase() :
                    this.textTransform == 'initial' ? (element.pro_name_site[0].toUpperCase() + element.pro_name_site.substr(1).toLowerCase()) :
                    this.textTransform == 'capitalize' ? (element.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })): element.pro_name_site
            });
        }
    }
}
</script>
